import storage from '@/utils/storage';

const storeStorage = {
  setItem(key, state) {
    storage.setItem(key, state, 'localStorage');
  },
  getItem(key) {
    return storage.getItem(key, 'localStorage');
  }
};

export default storeStorage;
